import { render, staticRenderFns } from "./TableBeds.vue?vue&type=template&id=5682e636&"
import script from "./TableBeds.vue?vue&type=script&lang=js&"
export * from "./TableBeds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports